// ** Third Party Imports
import { Navigate, type RouteObject } from 'react-router-dom'

// ** Utility Imports
import { lazyImport } from '@/shared/lib'

// ** Layout Imports
import { BlankLayout } from '@/app/layouts/BlankLayout'
import { LandingPageLayout } from '@/app/layouts/LandingPageLayout'

// ** Route Imports
// Public Routes
const { LoginPage } = lazyImport(
	async () => await import('@/pages/login'),
	'LoginPage'
)
const { XeroCallbackHandler } = lazyImport(
	// Add this line
	async () => await import('@/features/auth/login/ui/XeroCallback'),
	'XeroCallbackHandler'
)

const { RegisterPage } = lazyImport(
	async () => await import('@/pages/register'),
	'RegisterPage'
)
const { ForgotPasswordPage } = lazyImport(
	async () => await import('@/pages/forgot-password'),
	'ForgotPasswordPage'
)
const { NewPasswordPage } = lazyImport(
	async () => await import('@/pages/new-password'),
	'NewPasswordPage'
)
// Landing Page Routes
const { HomePage } = lazyImport(
	async () => await import('@/pages/home'),
	'HomePage'
)
const { HomePageNew } = lazyImport(
	async () => await import('@/pages/home-new'),
	'HomePageNew'
)
const { AboutPage } = lazyImport(
	async () => await import('@/pages/about'),
	'AboutPage'
)
const { AboutPageNew } = lazyImport(
	async () => await import('@/pages/about-new'),
	'AboutPageNew'
)
const { FaqPage } = lazyImport(
	async () => await import('@/pages/faq'),
	'FaqPage'
)
const { ContactPage } = lazyImport(
	async () => await import('@/pages/contact'),
	'ContactPage'
)
const { PrivacyPolicyPage } = lazyImport(
	async () => await import('@/pages/privacy-policy'),
	'PrivacyPolicyPage'
)
const { PrivacyPolicyPageNew } = lazyImport(
	async () => await import('@/pages/privacy-policy-new'),
	'PrivacyPolicyPageNew'
)
const { TermsAndConditionsPage } = lazyImport(
	async () => await import('@/pages/terms-and-conditions'),
	'TermsAndConditionsPage'
)

const { CalculateTaxDeductionFormPage } = lazyImport(
	async () => await import('@/pages/calculate-tax-deduction-form'),
	'CalculateTaxDeductionFormPage'
)

export const publicRoutes: RouteObject[] = [
	{
		element: <BlankLayout />,
		children: [
			{
				path: '/xerocallback',
				element: <XeroCallbackHandler />
			},
			{
				path: '/login',
				element: <LoginPage />
			},
			{
				path: '/register',
				element: <RegisterPage />
			},
			{
				path: '/verify-email',
				element: <RegisterPage />
			},
			{
				path: '/forgot-password',
				element: <ForgotPasswordPage />
			},
			{
				path: '/new-password',
				element: <NewPasswordPage />
			}
		]
	},
	{
		element: <BlankLayout withBackgroundImage={false} />,
		children: [
			{
				path: '/tax-calculation-form',
				element: <CalculateTaxDeductionFormPage />
			}
		]
	},
	{
		element: <LandingPageLayout />,
		children: [
			{
				path: '/home',
				element: <HomePageNew />
			},
			{
				path: '/about',
				element: <AboutPageNew />
			},
			{
				path: '/privacy-policy',
				element: <PrivacyPolicyPageNew />
			}
			// new landing page does not have the following routes
			// {
			// 	path: '/faq',
			// 	element: <FaqPage />
			// },
			// {
			// 	path: '/contact',
			// 	element: <ContactPage />
			// },
			// {
			// 	path: '/privacy-policy',
			// 	element: <PrivacyPolicyPage />
			// },
			// {
			// 	path: '/terms-conditions',
			// 	element: <TermsAndConditionsPage />
			// }
		]
	},
	{
		path: '*',
		element: <Navigate to='/login' replace />
	}
]
